export const LOAD_REQUESTED = "WIDGET_HEADER/LOAD_REQUESTED";
export const LOAD_SUCCESS = "WIDGET_HEADER/LOAD_SUCCESS";
export const LOAD_FAIL = "WIDGET_HEADER/LOAD_FAIL";

// eslint-disable-next-line no-unused-vars
export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadExecutiveApproveBy = data => ({ type: LOAD_REQUESTED, data });
export const successLoadExecutiveApproveBy = data => ({ type: LOAD_SUCCESS, data });
export const failLoadExecutiveApproveBy = data => ({ type: LOAD_FAIL, data });
